import styled from '@emotion/styled';

const CardWrapper = styled.div`
  width: 100%;
  height: fit-content;
  padding: 20px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  p {
    margin: 0;
  }
`;

const CardTitle = styled.p`
  font-size: 20px;
  font-weight: 700;
`;

const SectionTitle = styled.strong``;

const InfoTitle = styled.p`
  font-size: inherit;
  line-height: 1;
  color: rgba(0, 0, 0, 0.65);
`;

const InfoContent = styled.span`
  font-size: inherit;
  line-height: 1;
`;

const BasicSection = styled.section`
  display: flex;
  gap: 10px;
`;

const BasicIcon = styled.div`
  width: 60px;
  height: 70px;
  border-radius: 5px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
`;

const BasicInfos = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5px 0;
`;

const StatusSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ElectricStatus = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

const UsageStatus = styled.div`
  display: flex;
`;

const CurrentStatus = styled.div`
  display: flex;
  gap: 5px;
`;

export {
  CardWrapper,
  CardTitle,
  SectionTitle,
  InfoTitle,
  InfoContent,
  BasicSection,
  BasicIcon,
  BasicInfos,
  StatusSection,
  ElectricStatus,
  UsageStatus,
  CurrentStatus,
};
